<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="账号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.userAccount" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="用户名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.userName" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col  :lg="5" :xl="5">
          <el-form-item label="所属系统" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="pagination.authSystem">
            </el-input>
          </el-form-item>
        </el-col> -->
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="用户管理">
                <el-button v-authority="'BACK_MENU8_M2_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <el-table-column prop="userAccount" label="账号" />
                <el-table-column prop="userName" label="用户名称" />
                <el-table-column prop="userEmail" label="用户邮箱" />
                <el-table-column prop="userPhone" label="联系号码" />
                <el-table-column prop="empNumber" label="用户工号" />
                <el-table-column prop="xaEmpNumber" label="XA工号" />
                <el-table-column prop="roleName" label="角色" />
                <el-table-column prop="whCode" label="所属通道" />
                <el-table-column prop="createTime" label="工作时间" />
                <el-table-column prop="deleteFlag" label="状态">
                    <template slot-scope="scope">
                        {{ scope.row.deleteFlag ? "已禁用" : "正常" }}
                    </template>
                </el-table-column>
								<el-table-column prop="approveFlag" label="审批权限">
                    <template slot-scope="scope">
                        {{ scope.row.approveFlag ? "允许" : "不允许" }}
                    </template>
								</el-table-column>
                <el-table-column label="角色操作" width="120">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU8_M2_B5'" size="mini" type="primary" @click="
                (roleeditBoxShow = true),
                  getadd(scope.row),
                  getWarehouseAll(scope.row.fcCode),
                  vieWWhCode(scope.row.whCode)
              ">角色操作</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU8_M2_B2'" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU8_M2_B3'" type="danger" @click="deleteRow(scope.row.userId)" size="mini" plain icon="el-icon-delete" />
                        <el-button v-authority="'BACK_MENU8_M2_B4'" type="warning" plain size="mini" icon="el-icon-refresh" @click="resetPasswd(scope.row.userId)" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 角色操作 -->
        <el-dialog :title="'角色编辑——' + rolemainObj.userAccount" :close-on-click-modal="false" :visible.sync="roleeditBoxShow" class="fromDialog" :style="$popups.popups(0.5,0.4)">
            <span class="formClass">
                <el-form v-show="showRoleBox" :inline="true" label-position="top" :model="rolemainObj" :rules="roleRules" ref="rolemainObj">
                    <el-col :lg="12" :xl="12">
                        <el-form-item label="角色" prop="roleId"  class="EL-Form-Item">
                            <el-select v-model.trim="rolemainObj.roleId" placeholder="请选择" style="width: 250px">
                                <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName" :value="item.roleId" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12" :xl="12">
                        <el-form-item label="通道编号" prop="whCode" class="EL-Form-Item">
                            <el-select v-model="rolemainObj.whCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </span>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button size="small" style="float: left" type="info" v-if="showRoleBox" @click="deleteRole()">删除角色</el-button> -->
                <!-- <el-button size="small" style="float: left" type="info" v-else @click="
            (showRoleBox = !showRoleBox),
              (rolemainObj.roleId = ''),
              (rolemainObj.fcCode = ''),
              (rolemainObj.whCode = '')
          ">添加角色</el-button> -->
                <!-- <el-button size="small" type="info" @click="close(), (roleeditBoxShow = false)">取 消</el-button>
                <el-button size="small" type="primary" @click="insertUserRoleId()">确 定</el-button>
            </span> -->
             <div slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="danger" v-if="showRoleBox" @click="deleteRole()">删除角色</el-button>
                <el-button size="small" type="info" @click="close(), (roleeditBoxShow = false)">取 消</el-button>
                <el-button size="small" type="primary" @click="insertUserRoleId()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" width="700px" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-form-item label="账号" prop="userAccount">
                        <el-input v-model="mainObj.userAccount"> </el-input>
                    </el-form-item>
                    <el-form-item label="用户名称" prop="userName">
                        <el-input v-model="mainObj.userName"> </el-input>
                    </el-form-item>
                    <el-form-item label="用户工号" prop="empNumber">
                        <el-input v-model="mainObj.empNumber"> </el-input>
                    </el-form-item>
                    <el-form-item label="XA工号" prop="empNumber">
                        <el-input v-model="mainObj.xaEmpNumber"> </el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="userEmail">
                        <el-input v-model="mainObj.userEmail"> </el-input>
                    </el-form-item>
                    <el-form-item label="电话" prop="userPhone">
                        <el-input v-model="mainObj.userPhone"> </el-input>
                    </el-form-item>
                    <!-- <el-form-item label="部门" prop="userTitle">
                        <el-input v-model="mainObj.userTitle"> </el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="职位" prop="userDeptitle">
                        <el-input v-model="mainObj.userDeptitle"> </el-input>
                    </el-form-item> -->
                    <el-form-item label="是否产线经理" prop="managerFlag">
                        <el-select v-model="mainObj.managerFlag" placeholder="请选择">
                            <el-option label="是" :value="true"></el-option>
                            <el-option label="否" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否值班长" prop="classFlag">
                        <el-select v-model="mainObj.classFlag" placeholder="请选择">
                            <el-option label="是" :value="true"></el-option>
                            <el-option label="否" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审批权限" prop="approveFlag">
                        <el-select v-model="mainObj.approveFlag" placeholder="请选择">
                            <el-option label="允许" :value="true"></el-option>
                            <el-option label="不允许" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="mainObj = {},editBoxShow = false">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        time
    } from 'echarts';
    export default {
        name: "AuxiMaterial",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    userAccount: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    userName: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    empNumber: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },
                roleRules: {
                    fcCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    roleId: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                },
                showRoleBox: true,
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                mainObj: {},
                pagination: {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    userAccount: "",
                    userName: "",
                },
                mainData: [{
                    userId: null,
                    userAccount: "",
                    userName: "",
                    userEmail: "",
                    userPhone: "",
                    empNumber: "",
                    createTime: "",
                    managerFlag:"",
                    classFlag:"",
                }, ],
                roleeditBoxShow: false, //角色编辑框
                rolemainObj: {
                    syrId: "",
                    userId: "",
                    userAccount: "",
                    roleId: "",
                    fcCode: "",
                    whCode: "",
                },
                roleList: [],
                //获取工厂信息
                factoryList: [],

                //获取通道
                warehouseCheckboxList: "",
                warehouseList: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/user/userAll",
                        method: "GET",
                        params: {
                            pageSize: this.pagination.pageSize,
                            pageNum: this.pagination.pageNum,
                            userAccount: this.pagination.userAccount,
                            userName: this.pagination.userName,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },

            getadd(row) {
                this.rolemainObj = {
                    syrId: row.syrId,
                    userId: row.userId,
                    userAccount: row.userAccount,
                    roleId: row.roleId,
                    fcCode: row.fcCode,
                    whCode: row.whCode,
                }
            },

            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(
                        JSON.stringify({
                            userId: null,
                            userAccount: "",
                            userName: "",
                            userEmail: "",
                            userPhone: "",
                            empNumber: "",
                            xaEmpNumber: "",
                            createTime: "",
							approveFlag: false,
                            managerFlag:false,
                            classFlag: false,
                        })
                    );
                } else {
                    this.getAuxiMaterialData();
                    // setTimeout(() => {
                    // this.$refs.cascadeSearch.reSetData(this.mainObj.fcCode, this.mainObj.shopCode, this.mainObj.lineCode)
                    // }, 200)
                }
            },
            //新增
            add() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/user/userAdd",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "user：用户新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "user：用户新增成功";
                            }
                            this.logContent = "userAccount：" + this.mainObj.userAccount;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/user/updateUserId",
                            method: "PUT",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "user：用户修改成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "修改失败",
                                });
                                this.logRemarks = "user：用户修改失败";
                            }
                            this.logContent = "userAccount：" + this.mainObj.userAccount;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(userId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/user/deleteUserId",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    userId: userId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "user：用户删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "user：用户删除失败";
                                }
                                this.logContent = "userId：" + userId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },
            //重置密码
            resetPasswd(userId) {
                this.$confirm("此操作将重置该用户密码, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/user/resetPasswd",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    userId: userId,
                                    operaAccount: localStorage.getItem("user") || "",
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "设置成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "user：用户重置密码成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: resp.message,
                                    });
                                    this.logRemarks = "user：用户重置密码失败";
                                }
                                this.logContent = "userId：" + userId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch((error) => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            //角色查询
            roleAll() {
                this.$http
                    .request({
                        url: "/api/role/getRoleAll",
                        method: "GET",
                        params: {
                            pageNum: "",
                            pageSize: "",
                            roleCode: "",
                            roleName: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.roleList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //删除角色
            deleteRole() {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        if (!this.rolemainObj.roleId) {
                            this.roleeditBoxShow = false;
                            return;
                        }
                        this.$http
                            .request({
                                url: "/api/userRole/deleteRoleId",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    syrId: this.rolemainObj.syrId || "",
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "userRole：用户删除角色成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "userRole：用户删除角色失败";
                                }
                                this.logContent = "syrId" + this.rolemainObj.syrId;
                                this.systemLog();
                                this.roleeditBoxShow = false;
                                this.close();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },
            //角色修改
            insertUserRoleId() {
                // var listString = this.warehouseCheckboxList.join(",");
                // this.rolemainObj.whCode = listString;
                if (this.submitForm('rolemainObj')) {
                    this.$http
                        .request({
                            url: "/api/userRole/insertUserRoleId",
                            method: "POST",
                            showLoading: true,
                            params: {
                                syrId: this.rolemainObj.syrId || null,
                                userId: this.rolemainObj.userId || null,
                                userAccount: this.rolemainObj.userAccount || null,
                                roleId: this.rolemainObj.roleId || null,
                                //fcCode: this.rolemainObj.fcCode || null,
                                fcCode: localStorage.getItem("fcCode"),
                                whCode: this.rolemainObj.whCode || "",
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "用户分配角色成功",
                                    type: "success",
                                });
                                this.logRemarks = "userRole：用户分配角色成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "userRole：用户分配角色失败";
                            }
                            this.logContent =
                                "userAccount：" +
                                this.rolemainObj.userAccount +
                                "roleId：" +
                                this.rolemainObj.roleId;
                            this.systemLog();
                            this.roleeditBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            close() {
                this.rolemainObj = {
                    userId: "",
                    userAccount: "",
                    roleId: "",
                    fcCode: "",
                    whCode: "",
										approveFlag: false,
                };
                this.warehouseList = [];
                this.warehouseCheckboxList = "";
            },
            //获取数据
            getFactoryAll() {
                this.$http
                    .request({
                        url: "/api/factory/getFactoryAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.factoryList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            vieWWhCode(whCode) {
                // if (whCode != undefined) {
                //     let ids = whCode.split(',')
                //     for (let index = 0; index < ids.length; index++) {
                //         this.warehouseCheckboxList.push(ids[index])
                //     }
                // }
                this.warehouseCheckboxList = whCode;
            },
            //获取数据
            getWarehouseAll() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouseAll",
                        method: "GET",
                        params: {
                            pageSize: 0,
                            pageNum: 0,
                            total: 0,
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                            whName: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                            console.log("rolemainObj", this.rolemainObj)
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //重置
            resetData() {
                this.pagination = {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    userAccount: "",
                    userName: "",
                };
                this.getAuxiMaterialData();
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "用户管理",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            this.roleAll();
            this.getFactoryAll();
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>